import { render, staticRenderFns } from "./ExcelMapperWrapper.vue?vue&type=template&id=0d5e1f66&scoped=true"
import script from "./ExcelMapperWrapper.vue?vue&type=script&lang=ts"
export * from "./ExcelMapperWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e1f66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5e1f66')) {
      api.createRecord('0d5e1f66', component.options)
    } else {
      api.reload('0d5e1f66', component.options)
    }
    module.hot.accept("./ExcelMapperWrapper.vue?vue&type=template&id=0d5e1f66&scoped=true", function () {
      api.rerender('0d5e1f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ExcelMapperWrapper.vue"
export default component.exports